// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1I8MB","colCheckbox":"styles_colCheckbox__-KhN3"};